import React from 'react';
import '../../assets/css/style.css';
import './ErrorPage.css';

const ErrorPage = () => {
    return (
        <>
            {/* <div className="header-layer-bg"></div> */}

            <main className="page-wrapper">
                <section className="error-page">
                    <div className="container">
                        <div className="row">
                            <div className="col col-lg-10 offset-lg-1">
                                <div className="error-content text-center">
                                    <div className="heading">404</div>
                                    <h1 className='py-3'>Pagina non trovata</h1>
                                    <p className='pb-3'>Oops! La pagina che stai cercando non esiste. Potrebbe essere stata spostata o cancellata.</p>

                                    <div className="btn_group">
                                        <a href='/' className="button">Torna alla pagina iniziale</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
        </>
    );
};

export default ErrorPage;